<template>
  <div class="tabson1" >
    <!--<label >{{queryData.taxReportTime}} </label>
    <label >{{queryData.taxCompanyName}} </label>
    税金申报情况：<label style="color: #5daf34">{{ queryData.taxReportStatus | bspTableFilter({'1':'dict','2':dicts}) }}</label>
    <label style="color: #409EFF">&ensp;{{ queryData.taxPayStatus | bspTableFilter({'1':'dict','2':dicts}) }}</label>-->

<!--    <el-button type="primary" size="small" @click="backToCodeSet()" style="float: right">返回</el-button>-->
    <bsp-table
      :data.sync="list"
      ref="accountTable"
			id="accountTable"
      show-footer
      :ciic-data-filter.sync="listQuery"
      :footer-method="footerMethod"
      :custom-config="{storage: true}"
      @ciic-data-refresh="_getTaxNormalWagesList"
      :showPagination="listQuery.page"
      style="width: 100%"
    >
      <bsp-table-column
        field="A0010001"
        title="工号"

        width="10%">
        <template slot-scope="scope">{{ scope.row.A0010001 }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="empName"
        title="姓名"

        width="10%">
        <template slot-scope="scope">{{ scope.row.empName }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="idCardType"
        filter-type="select"
        title="证照类型"
        width="10%">
        <template slot-scope="scope">{{ scope.row.idCardType  | bspTableFilter({'1':'dict','2':dicts}) }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="idCard"
        label="证照号码"
        width="10%">
        <template slot-scope="scope">{{ scope.row.idCard }}</template>
      </bsp-table-column>
      <bsp-table-column
        field=""
        title="所得项目"
        width="12%">
        <template slot-scope="scope"></template>
      </bsp-table-column>
      <bsp-table-column
        field="thisIncome"
        title="收入"
        width="10%">
        <template slot-scope="scope">{{ scope.row.thisIncome }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="otherFree"
        title="免税收入"
        width="10%">
        <template slot-scope="scope">{{ scope.row.otherFree }}</template>
      </bsp-table-column>
      <bsp-table-column
        field=""
        title="是否提供财产原值凭证"
        width="10%">
        <template slot-scope="scope"></template>
      </bsp-table-column>
      <bsp-table-column
        field=""
        title="财产原值"
        width="10%">
        <template slot-scope="scope"></template>
      </bsp-table-column>
      <bsp-table-column
        field=""
        title="允许扣除的税费"
        width="10%">
        <template slot-scope="scope"></template>
      </bsp-table-column>
      <bsp-table-column
        field=""
        title="投资抵扣"
        width="10%">
        <template slot-scope="scope"></template>
      </bsp-table-column>
      <bsp-table-column
        field="donationFree"
        title="实际捐赠额"
        width="10%">
        <template slot-scope="scope">{{ scope.row.donationFree }}</template>
      </bsp-table-column>
      <bsp-table-column
        field=""
        title="捐赠方式"
        width="10%">
        <template slot-scope="scope"></template>
      </bsp-table-column>
      <bsp-table-column
        field="donationFree"
        title="准予扣除的捐赠额"
        width="10%">
        <template slot-scope="scope">{{ scope.row.donationFree }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="taxRate"
        title="税率"
        width="10%">
        <template slot-scope="scope">{{ scope.row.taxRate }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="allTaxFreeTotal"
        title="减免税额"
        width="10%">
        <template slot-scope="scope">{{ scope.row.allTaxFreeTotal }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="remarks"
        title="备注"
        width="10%">
        <template slot-scope="scope">{{ scope.row.remarks }}</template>
      </bsp-table-column>
    </bsp-table>


  </div>
</template>
<script>
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import {getTaxTransPropertyList} from "@/api/tax/tax";
  import {mapGetters} from 'vuex';
  import XEUtils from 'xe-utils';

  export default {
    name: "tabson1",
    components: { bspTableColumn, bspTable},
    props:{
      currentTab:{
        type:String,
        default:''
      }
    },
    watch: {

    },
    created(){
      this.queryData=this.$route.query
      // console.log(this.batchId)
      this._getTaxTransPropertyList()

    },
    mounted(){

    },
    computed: {
      ...mapGetters([
        'dicts',
        'pms'
      ]),
    },
    data() {
      return {
        sumListCode:[
          'thisIncome',
          'otherFree',
          'otherFee',
          'allTaxFreeTotal',
          'donationFree',
        ],//需要合计的列信息
        queryData:null,
        list:[],
        listQuery:{
          limit: 20,
          page: 1,
          total: 0,
          batchId:this.$route.query.batchId,
          taxType:this.$route.query.taxType

        }
      }
    },
    methods:{
      footerMethod ({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 3) {
              return '合计'
            }
            if (this.sumListCode.includes(column.property)) {
              return XEUtils.sum(data, column.property)
            }
            return null
          })
        ]
      },
      _getTaxTransPropertyList(){
        getTaxTransPropertyList(this.listQuery).then(res => {
          console.log(res);
          this.listQuery.total = res.data.total
          this.list = res.data.records
        } ).catch((error) => {
          console.log("错误信息"+error)
        })
      },
      backToCodeSet(){
        this.$router.go(-1)
      },
    }

  }
</script>
<style scoped="scoped">
	 #accountTable >>> .vxe-table .vxe-table--header-wrapper{
		 width: 100%;
	 }
</style>
